import { GUEST,LOCAL_STORAGE_ROLES,LOCAL_STORAGE_TOKEN } from "../constans/roles";

//import { GUEST, USER, ADMIN,LOCAL_STORAGE_ROLES,LOCAL_STORAGE_TOKEN } from './constans/roles';

export const setLocalStorage = () => {
    let token = localStorage.getItem(LOCAL_STORAGE_TOKEN);
    let rolesString = localStorage.getItem(LOCAL_STORAGE_ROLES);

    if (!token) {
      localStorage.setItem(LOCAL_STORAGE_TOKEN, "");
      localStorage.setItem(LOCAL_STORAGE_ROLES, "");
    }

    return [token,rolesString]
}

function hasSameElement(tablica1, tablica2) {
  return tablica1.some(element => tablica2.includes(element));
}

export const allowAccess = (requiredRoles = [GUEST]) => {
    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN) || "";
    const userPermissions = localStorage.getItem(LOCAL_STORAGE_ROLES) || "";
    const roles = userPermissions ? userPermissions.split(',').filter(Boolean) : [];

    if (!token) return false;

  if (!hasSameElement(roles,requiredRoles)) return false;
  

    return true;
  };
